import { render, staticRenderFns } from "./XTable.vue?vue&type=template&id=6ea1f144&scoped=true&"
import script from "./XTable.vue?vue&type=script&lang=js&"
export * from "./XTable.vue?vue&type=script&lang=js&"
import style0 from "./XTable.vue?vue&type=style&index=0&id=6ea1f144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1f144",
  null
  
)

export default component.exports